import { photoFileExtensionList } from "../../../constants/file_extension";
import { useStore } from "../../../stores/use_global_state";
import MainBlob from "../../animate/MainBlob";
import FileInput from "../FileInput/FileInput";
import styles from "./MainBlock.module.scss";
import * as ga from "../../../lib/ga";
import { useState } from "react";
import { gaCreditsLimit } from "../../../utils/gaCreditsLimit";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { getEraseAndReplaceTaskStatus } from "../../../pages/api/apiEraseAndReplace";

const MainBlock = ({ dictionary, checkNonAuth }) => {
	const { query, replace, pathname } = useRouter();

	const { state, dispatch } = useStore();
	const [uploadFileLoading, setUploadFileLoading] = useState(false);

	const gaUploadImage = () => {
		ga.event({ action: "Erase & Replace: upload image", params: { event_category: "Erase&Replace page" } });
	};

	const uploadFile = async (files) => {
		if (checkNonAuth()) return;
		setUploadFileLoading(true);

		if (!state.isAuth) {
			const freeLimit = JSON.parse(localStorage.getItem("freeLimit"));

			if (freeLimit !== null && freeLimit.image < 1) {
				dispatch({ type: "setVideoError", error_msg: "free_limit_img", error_code: "free_limit_img" });
				setUploadFileLoading(false);

				return false;
			}
		}

		if (state.isAuth) {
			if (state?.accountData?.plan === "free" && state?.accountData?.total_credits < 1) {
				gaCreditsLimit("ERASE_REPLACE");
				dispatch({ type: "setVideoError", error_msg: "free_limit_img", error_code: "free_limit_img" });
				setUploadFileLoading(false);

				return false;
			}

			if ((state?.accountData?.plan === "pro" || state?.accountData?.plan === "promo") && state?.accountData?.total_credits < 1) {
				gaCreditsLimit("ERASE_REPLACE");
				dispatch({ type: "setVideoError", error_msg: "pro_limit", error_code: "pro_limit" });
				setUploadFileLoading(false);

				return false;
			}
		}

		gaUploadImage();
		let image = files[0];

		let fileExtension = image.name.split(".").pop();
		const ExtensionList = new Set(photoFileExtensionList);
		const errorMsg = dictionary["Extension .XX is not allowed. Only .mp4, .mov, .ts, .avi, .mkv, .webm, .mpg, .jpg, .png are allowed"]
			.replace("XX", fileExtension)
			.replace(" .mp4, .mov, .mkv, .webm,", "");

		if (fileExtension.toLowerCase() === "heif" || fileExtension.toLowerCase() === "heic") {
			const heic2any = (await import("heic2any")).default;

			fetch(URL.createObjectURL(image))
				.then((res) => {
					return res.blob();
				})
				.then((blob) => {
					return heic2any({ blob });
				})
				.then((conversionResult) => {
					const url = URL.createObjectURL(conversionResult);
					dispatch({
						type: "setEraseAndReplaceImg",
						img: [url],
						ids: null,
					});
					setUploadFileLoading(false);
				})
				.catch((e) => {
					dispatch({ type: "setVideoError", error_msg: errorMsg, error_code: "extension" });
					setUploadFileLoading(false);
				});
			return;
		}

		if (!ExtensionList.has(fileExtension.toLowerCase())) {
			dispatch({ type: "setVideoError", error_msg: errorMsg, error_code: "extension" });
			setUploadFileLoading(false);

			return false;
		}
		dispatch({ type: "setEraseAndReplaceImg", img: [URL.createObjectURL(image)], ids: null });
		setUploadFileLoading(false);
	};

	useEffect(
		() => {
			if (query.file && state?.temporaryFileStorage) return uploadFile(state.temporaryFileStorage);

			const recoveryTaskForFree = async () => {
				const { data } = await getEraseAndReplaceTaskStatus(query.id);
				dispatch({ type: "setEraseAndReplaceImg", img: [data.image_url], ids: null });
				replace(pathname);
				dispatch({ type: "setEraseAndReplaceTask", task: data });
			};

			if (query.id) recoveryTaskForFree();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[query]
	);

	return (
		<section className={styles.container}>
			<div className={styles.info}>
				<div className={styles.text}>
					<p className={styles.title}>{dictionary["erase_replace"]}</p>
					<h1 className={styles.description}>{dictionary["page_erase_description"]}</h1>
				</div>
				<div className={styles.photo_wrapper}>
					<video
						poster="/erase_and_replace/main_block/erase_poster.jpg"
						width="495"
						height="355"
						src="/erase_and_replace/main_block/erase_video.mp4"
						autoPlay
						loop
						muted
						playsInline
						className={styles.video}
					/>
				</div>
			</div>
			<div className={styles.inputWrapper}>
				<FileInput uploadFile={uploadFile} dictionary={dictionary} loading={uploadFileLoading} checkNonAuth={checkNonAuth} />
			</div>
			<MainBlob />
		</section>
	);
};

export default MainBlock;
